import * as React from 'react';

class CookiesPoliciesComponent extends React.Component {

  render() {

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-8">
              <h1 className="bold-title">
                Política de Cookies
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-12 col-md-4">
              <p className="breadcrumb text-right">
                Inicio > Política de Cookies
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <p>
                <strong>THE CROWD ANGEL, P.F.P., S.L.</strong> con domicilio en Madrid (28010), calle Orfila 10, 
                Bajos Izq, provista de N.I.F. número B-65640724 (España), utiliza cookies para el funcionamiento 
                de su sitio web.
              </p>
              <p>
                Las cookies son archivos de texto que contienen pequeñas cantidades de información que se descargan en
                su ordenador o dispositivo móvil cuando usted visita un sitio web. Las cookies se envían de vuelta al
                sitio web original en cada visita posterior, o a otro sitio web que las reconoce. Las cookies son útiles
                porque permiten a un sitio web reconocer el dispositivo del usuario. Las cookies pueden realizar
                diferentes funciones como permitir navegar entre las páginas de manera eficiente, recordando sus
                preferencias, y en general mejorar la navegación del usuario.
              </p>
              <p>
                En cuanto a los <strong>tipos de cookies</strong>, éstas se clasifican según la entidad que las
                gestione; así, tenemos
                las propias y las de terceros, según el plazo que permanecen activadas de sesión o persistentes, según
                su finalidad, técnicas, de personalización, de análisis, publicitarias y de publicidad comportamental:
              </p>
              <ul>
                <li>
                  <strong>SESIÓN:</strong> Cookies diseñadas para recabar y almacenar datos mientras el usuario accede a
                  una página web. Se utiliza para almacenar información que solo interesa conservar para la prestación
                  del servicio solicitado por el usuario en una sola ocasión.
                </li>
                <li>
                  <strong>PERSISTENTES:</strong> Cookies en el que los datos siguen almacenados en el terminal y pueden
                  ser accedidos y tratados durante un periodo definido por el responsable de la cookie, puede ir de unos
                  minutos a varios años.
                </li>
                <li>
                  <strong>TÉCNICA:</strong> Permiten al usuario la navegación a través de una página web, plataforma o
                  aplicación y la utilización de las diferentes opciones o servicios que en ella existan.
                </li>
                <li>
                  <strong>PERSONALIZACIÓN:</strong> Permiten al usuario acceder al servicio con algunas características
                  de carácter general predefinidas en función de una serie de criterios en el terminal del usuario.
                </li>
                <li>
                  <strong>ANÁLISIS:</strong> Permiten al responsable de las mismas, el seguimiento y análisis del
                  comportamiento de los usuarios de los sitios web a los que están vinculadas.
                </li>
                <li>
                  <strong>PUBLICITARIAS:</strong> Permiten la gestión, de la forma más eficaz posible, de los espacios
                  publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma
                  desde la que presta el servicio solicitado en base a criterios como el contenido editado o la
                  frecuencia en la que se muestran los anuncios.
                </li>
                <li>
                  <strong>PUBLICIDAD COMPORTAMENTAL:</strong> Permiten la gestión de los espacios publicitarios que el
                  editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio
                  solicitado. Se almacena con ellas información del comportamiento de los usuarios obtenida a través de
                  la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil
                  específico para mostrar publicidad en función del mismo.
                </li>
              </ul>
              <p>
                Le informamos de los tipos de cookies que se utilizan en este sitio web y su finalidad en&nbsp;
                <a
                  href="/public/cookies.pdf"
                  target="_blank"
                >
                  este enlace
                </a>
                .
              </p>
              <p>
                <strong>THE CROWD ANGEL, P.F.P., S.L.</strong> utiliza cookies de Google Analytics, la configuración de
                estas cookies
                está predeterminada por el servicio que ofrece Google, motivo por el cual le sugerimos que consulte la
                página de privacidad de Google Analytics, para obtener más información sobre las cookies que usa y cómo
                deshabilitarlas (entendiéndose que no somos responsables del contenido o la veracidad de los sitios web
                de terceros).
              </p>
              <p>
                También puedes ver:
              </p>
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/policies/cookies/"
                  >
                    https://www.facebook.com/policies/cookies/
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/legal/cookie-policy?_l=es_ES"
                  >
                    https://www.linkedin.com/legal/cookie-policy?_l=es_ES
                  </a>
                </li>
                <li>
                  <a
                    href="https://support.google.com/dfp_premium/answer/2839090?hl=es"
                  >
                    https://support.google.com/dfp_premium/answer/2839090?hl=es
                  </a>
                </li>
              </ul>
            </div>
            <div className="gap-20"/>
            <div className="col-sm-12">
              <h3>
                Desactivación de las cookies
              </h3>
              <p>
                El Usuario puede libremente decidir acerca de la implantación o no en su disco duro de nuestras cookies
                así como su eliminación, siguiendo el procedimiento establecido en la sección de ayuda de su navegador.
                El usuario puede también configurar su navegador para aceptar o rechazar por defecto todas las cookies o
                para recibir un aviso en pantalla de la recepción de cada cookie y decidir en ese momento su
                implantación o no en su disco duro.
              </p>
              <p>
                A continuación, le facilitamos los enlaces a los fabricantes de dispositivos y navegadores para la
                gestión o desactivación de cookies en su navegador:
              </p>
              <ul>
                <li>
                  <a
                    href="http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-in-internet-explorer-9"
                    target="_blank"
                  >
                    Internet Explorer
                  </a>
                </li>
                <li>
                  <a
                    href="https://support.google.com/chrome/answer/95647?hl=es"
                    target="_blank"
                  >
                    Goolge Chrome
                  </a>
                </li>
                <li>
                  <a
                    href="http://support.apple.com/kb/HT1677?viewlocale=es_ES"
                    target="_blank"
                  >
                    Safari
                  </a>
                </li>
                <li>
                  <a
                    href="https://support.mozilla.org/es/kb/Borrar%20cookies"
                    target="_blank"
                  >
                    Firefox
                  </a>
                </li>
                <li>
                  <a
                    href="http://help.opera.com/Linux/10.60/es-ES/cookies.html"
                    target="_blank"
                  >
                    Opera
                  </a>
                </li>
                <li>
                  <a
                    href="http://support.google.com/android/?hl=es"
                    target="_blank"
                  >
                    Android
                  </a>
                </li>
                <li>
                  <a
                    href="http://support.google.com/android/?hl=es"
                    target="_blank"
                  >
                    BlackBerry
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.windowsphone.com/es-es/how-to/wp7/web/changing-privacy-and-other-browser-settings"
                    target="_blank"
                  >
                    Windows Phone
                  </a>
                </li>
              </ul>
              <p>
                Si desea tener un mayor control sobre la instalación de cookies, puede instalar programas o complementos
                a su navegador, conocidos como herramientas de “Do Not Track”, que le permitirán escoger aquellas
                cookies que desea permitir.
              </p>
              <p>
                El hecho de que el Usuario configure su navegador para rechazar todas las cookies o expresamente
                nuestras cookies puede suponer que no sea posible acceder a algunos de los servicios y que su
                experiencia en nuestra web pueda resultar menos satisfactoria.
              </p>
              <p className="c-black-text">
                Actualizado en mayo de 2018
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CookiesPoliciesComponent;



// WEBPACK FOOTER //
// ./src/modules/privacy-and-cookies/CookiesPolicies.component.tsx